module.exports = __webpack_public_path__ + "img/bright-yellow.235b2a42.png";